import { Component, Renderer, ElementRef } from '@angular/core';
import { PopoverEditableIdNameGenericDropdownComponent } from './popover-editable-id-name-generic-dropdown.component';
import { CommonService } from '../../_services';
import { IIdNameGeneric } from '../../_entities';

@Component({

    selector: 'popover-country-code-name-dropdown',
    template: require('./popover-editable-dropdown.base.template.html')
})
export class PopoverCountryCodeNameDropDownComponent extends PopoverEditableIdNameGenericDropdownComponent<string> {

    constructor(
        private readonly commonService: CommonService,
        protected renderer: Renderer,
        protected element: ElementRef) {
        super(renderer, element);
    }

    protected getItems(): Promise<string[]> {
        if (this.dropdownItems) {
            return Promise.resolve(this.dropdownItems.map(r => r.id));
        }

        return this.commonService.getCountriesList().then(result => {
            const countries: IIdNameGeneric<string>[] = [];
            for (let country of result) {
                countries.push({ id: country.code, name: country.name });
            }
            this.dropdownItems = countries;
            return this.dropdownItems.map(r => r.id);
        });

    }

    protected getValue(itemToFind: string): any {
        return itemToFind && this.dropdownItems ? this.dropdownItems.find(x => x.id === itemToFind) : null;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/popover-country-code-name-dropdown.component.ts